import { IconButton } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

import { StyledButton } from "./styles";

type ExportAllActionButtonProps = {
    isDisabled?: boolean;
    isLoading?: boolean;
    onClick(): void;
};

const ExportAllContactsButton = (props: ExportAllActionButtonProps) => {
    const { isDisabled = false, isLoading = false, onClick } = props;

    return (
        <StyledButton>
            <PlainTooltip
                enabled={!isDisabled}
                tooltipContent={translate("si.contacts_search.export-all.excel.tooltip")}
            >
                <div>
                    <IconButton
                        type="flat"
                        iconName="share"
                        isDisabled={isDisabled}
                        isLoading={isLoading}
                        onClick={onClick}
                        dataAutomation="contacts-actions-panel.export-all-action-button"
                    >
                        {translate("si.contacts_search.export-all.excel")}
                    </IconButton>
                </div>
            </PlainTooltip>
        </StyledButton>
    );
}

export default ExportAllContactsButton;
